export default __webpack_public_path__ + "259997f54b5967d8e8354bc3f8b92a22.png";